var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRsReachstacker = function SvgRsReachstacker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2 87.3c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1.1 4 3.2 7.1 7.1 7.1ZM96.7 87.3c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1 0 4 3.2 7.1 7.1 7.1Z",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67.5h14.2l5.7 17h28.3l5.7-17h19.8M27.3 39.2H7.5v8.5h19.8v-8.5ZM17.4 30.7v8.5",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 73.2h11.3L69 60.4c.5-.9 1.4-1.4 2.4-1.4h4.1c1.6 0 2.8 1.3 2.8 2.8v11.3H84M61.3 73.2h17M52.8 73.2 67 42M101 36.4 16 22.2l-2.8 5.7 85 19.8 2.8-11.3ZM93.7 46.7l-6.9 20.8",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRsReachstacker;